import 'Styles/templates/collection.scss';
import { collectionInstance } from '../components/collection';

window.collectionInstance = collectionInstance;
